var map = {
	"./Leagues/BIG10/BIG10.png": 4450,
	"./Leagues/EPL/EPL.png": 4242,
	"./Leagues/MLB/MLBDark.png": 7078,
	"./Leagues/NBA/NBA.png": 8330,
	"./Leagues/NFL/NFL.png": 302,
	"./Leagues/WNBA/WNBA.png": 6712,
	"./Sports/Baseball.png": 7436,
	"./Sports/Basketball.png": 7113,
	"./Sports/BeachVolleyball.png": 3191,
	"./Sports/Curling.png": 7100,
	"./Sports/Cycling.png": 2597,
	"./Sports/FigureSkating.png": 969,
	"./Sports/Football.png": 9315,
	"./Sports/Golf.png": 9424,
	"./Sports/HorseRacing.png": 5279,
	"./Sports/IMSA.png": 5954,
	"./Sports/IndyCar.png": 3536,
	"./Sports/Motorcross.png": 8093,
	"./Sports/Motorsports.png": 9836,
	"./Sports/NotreDame.png": 4625,
	"./Sports/Rugby.png": 167,
	"./Sports/Skating.png": 2837,
	"./Sports/Skiing_Snowboarding.png": 1751,
	"./Sports/SnowSports.png": 3196,
	"./Sports/Soccer.png": 5089,
	"./Sports/SpeedSkating.png": 2636,
	"./Sports/Supercross.png": 1359,
	"./Sports/Swimming.png": 1211,
	"./Sports/Tennis.png": 4949,
	"./Sports/TrackField.png": 3763,
	"./Sports/_Rugby.png": 5352,
	"./Sports/_Tennis.png": 1088,
	"./Sports/_TrackField.png": 9414,
	"./Teams/big10/BIG10001_Illinois.png": 6001,
	"./Teams/big10/BIG10002_Indiana.png": 2905,
	"./Teams/big10/BIG10003_Iowa.png": 9440,
	"./Teams/big10/BIG10004_Maryland.png": 5559,
	"./Teams/big10/BIG10005_Michigan_State.png": 5894,
	"./Teams/big10/BIG10006_Michigan.png": 2897,
	"./Teams/big10/BIG10007_Minnesota.png": 7326,
	"./Teams/big10/BIG10008_Nebraska.png": 9142,
	"./Teams/big10/BIG10009_Northwestern.png": 6391,
	"./Teams/big10/BIG10010_Ohio_State.png": 8539,
	"./Teams/big10/BIG10011_Penn_State.png": 7456,
	"./Teams/big10/BIG10012_Purdue.png": 683,
	"./Teams/big10/BIG10013_Rutgers.png": 2485,
	"./Teams/big10/BIG10014_Wisconsin.png": 8739,
	"./Teams/big10/BIG10015_oregon_ducks.png": 8984,
	"./Teams/big10/BIG10016_ucla_bruins.png": 4431,
	"./Teams/big10/BIG10017_usc_trojans.png": 564,
	"./Teams/big10/BIG10018_washington_huskies.png": 3743,
	"./Teams/epl/EPL001_Arsenal.png": 750,
	"./Teams/epl/EPL002_Aston_Villa.png": 3909,
	"./Teams/epl/EPL003_Bournemouth.png": 4410,
	"./Teams/epl/EPL004_Brentford.png": 9141,
	"./Teams/epl/EPL005_Brighton_Hove_Albion.png": 336,
	"./Teams/epl/EPL006_Chelsea.png": 8696,
	"./Teams/epl/EPL007_Crystal_Palace.png": 9357,
	"./Teams/epl/EPL008_Everton.png": 5554,
	"./Teams/epl/EPL009_Fulham.png": 6951,
	"./Teams/epl/EPL010_Leeds_United.png": 6617,
	"./Teams/epl/EPL011_Leicester_City.png": 2295,
	"./Teams/epl/EPL012_Liverpool.png": 5958,
	"./Teams/epl/EPL013_Manchester_City.png": 2945,
	"./Teams/epl/EPL014_Manchester_United.png": 806,
	"./Teams/epl/EPL015_Newcastle_United.png": 6287,
	"./Teams/epl/EPL016_Nottingham_Forest.png": 9153,
	"./Teams/epl/EPL017_Southampton.png": 8923,
	"./Teams/epl/EPL018_Spurs.png": 8542,
	"./Teams/epl/EPL019_West_Ham_United.png": 3939,
	"./Teams/epl/EPL020_Wolverhampton_Wanderers.png": 4913,
	"./Teams/epl/EPL021_Sheffield_United.png": 6046,
	"./Teams/epl/EPL022_Burnley.png": 2098,
	"./Teams/epl/EPL023_Luton.png": 2588,
	"./Teams/epl/EPL024_Ipswich_Town.png": 9913,
	"./Teams/epl/EPL025_Sunderland.png": 1076,
	"./Teams/epl/EPL026_Hull_City.png": 9656,
	"./Teams/epl/EPL027_Coventry_City.png": 1098,
	"./Teams/mlb/Angels.png": 3675,
	"./Teams/mlb/Astros.png": 6469,
	"./Teams/mlb/Athletics.png": 7898,
	"./Teams/mlb/BlueJays.png": 9658,
	"./Teams/mlb/Braves.png": 4984,
	"./Teams/mlb/Brewers.png": 3705,
	"./Teams/mlb/Cardinals.png": 8454,
	"./Teams/mlb/Cubs.png": 3276,
	"./Teams/mlb/Diamondbacks.png": 661,
	"./Teams/mlb/Dodgers.png": 3257,
	"./Teams/mlb/Giants.png": 6039,
	"./Teams/mlb/Guardians.png": 4485,
	"./Teams/mlb/Mariners.png": 4178,
	"./Teams/mlb/Marlins.png": 7761,
	"./Teams/mlb/Mets.png": 8856,
	"./Teams/mlb/Nationals.png": 6424,
	"./Teams/mlb/Orioles.png": 5392,
	"./Teams/mlb/Padres.png": 7710,
	"./Teams/mlb/Phillies.png": 2315,
	"./Teams/mlb/Pirates.png": 9515,
	"./Teams/mlb/Rangers.png": 2451,
	"./Teams/mlb/Rays.png": 6994,
	"./Teams/mlb/Reds.png": 3221,
	"./Teams/mlb/Redsox.png": 2364,
	"./Teams/mlb/Rockies.png": 8613,
	"./Teams/mlb/Royals.png": 3013,
	"./Teams/mlb/Tigers.png": 4417,
	"./Teams/mlb/Twins.png": 1256,
	"./Teams/mlb/Whitesox.png": 2518,
	"./Teams/mlb/Yankees.png": 9425,
	"./Teams/mlb/twitter.png": 472,
	"./Teams/nba/NBA001_Hawks.png": 1554,
	"./Teams/nba/NBA002_Celtics.png": 168,
	"./Teams/nba/NBA003_Nets.png": 7944,
	"./Teams/nba/NBA004_Hornets.png": 9618,
	"./Teams/nba/NBA005_Bulls.png": 8750,
	"./Teams/nba/NBA006_Cavaliers.png": 9877,
	"./Teams/nba/NBA007_Mavericks.png": 1545,
	"./Teams/nba/NBA008_Nuggets.png": 4552,
	"./Teams/nba/NBA009_Pistons.png": 354,
	"./Teams/nba/NBA010_Warriors.png": 2569,
	"./Teams/nba/NBA011_Rockets.png": 6980,
	"./Teams/nba/NBA012_Pacers.png": 6138,
	"./Teams/nba/NBA013_Clippers.png": 3427,
	"./Teams/nba/NBA014_Lakers.png": 488,
	"./Teams/nba/NBA015_Grizzlies.png": 9254,
	"./Teams/nba/NBA016_Heat.png": 8700,
	"./Teams/nba/NBA017_Bucks.png": 4161,
	"./Teams/nba/NBA018_Timberwolves.png": 2377,
	"./Teams/nba/NBA019_Pelicans.png": 2206,
	"./Teams/nba/NBA020_Knicks.png": 6830,
	"./Teams/nba/NBA021_Thunder.png": 6072,
	"./Teams/nba/NBA022_Magic.png": 7696,
	"./Teams/nba/NBA023_76ers.png": 2673,
	"./Teams/nba/NBA024_Suns.png": 1750,
	"./Teams/nba/NBA025_TrailBlazers.png": 7409,
	"./Teams/nba/NBA026_Kings.png": 393,
	"./Teams/nba/NBA027_Spurs.png": 8427,
	"./Teams/nba/NBA028_Raptors.png": 4012,
	"./Teams/nba/NBA029_Jazz.png": 9635,
	"./Teams/nba/NBA030_Wizards.png": 9024,
	"./Teams/nfl/NFL001_BBILLS.png": 1242,
	"./Teams/nfl/NFL002_MDOLPHINS.png": 7149,
	"./Teams/nfl/NFL003_NEPATRIOTS.png": 9735,
	"./Teams/nfl/NFL004_NYJETS.png": 5662,
	"./Teams/nfl/NFL005_BRAVENS.png": 4283,
	"./Teams/nfl/NFL006_CBENGALS.png": 7442,
	"./Teams/nfl/NFL007_CBROWNS.png": 9942,
	"./Teams/nfl/NFL008_PSTEELERS.png": 3378,
	"./Teams/nfl/NFL009_HTEXANS.png": 4705,
	"./Teams/nfl/NFL010_ICOLTS.png": 3090,
	"./Teams/nfl/NFL011_JJAGUARS.png": 2504,
	"./Teams/nfl/NFL012_TTITANS.png": 5093,
	"./Teams/nfl/NFL013_BBRONCOS.png": 1843,
	"./Teams/nfl/NFL014_KCCHIEFS.png": 7292,
	"./Teams/nfl/NFL015_LVRAIDERS.png": 4969,
	"./Teams/nfl/NFL016_LACHARGERS.png": 6598,
	"./Teams/nfl/NFL017_DCOWBOYS.png": 2457,
	"./Teams/nfl/NFL018_NYGIANTS.png": 1049,
	"./Teams/nfl/NFL019_PEAGLES.png": 4820,
	"./Teams/nfl/NFL020_WCOMMANDERS.png": 1133,
	"./Teams/nfl/NFL021_CBEARS.png": 7748,
	"./Teams/nfl/NFL022_DLIONS.png": 8320,
	"./Teams/nfl/NFL023_GBPACKERS.png": 7324,
	"./Teams/nfl/NFL024_MVIKINGS.png": 101,
	"./Teams/nfl/NFL025_AFALCONS.png": 8985,
	"./Teams/nfl/NFL026_CPANTHERS.png": 2865,
	"./Teams/nfl/NFL027_NOSAINTS.png": 3489,
	"./Teams/nfl/NFL028_TBBUCCANEERS.png": 9298,
	"./Teams/nfl/NFL029_ACARDINALS.png": 1948,
	"./Teams/nfl/NFL030_LARAMS.png": 4260,
	"./Teams/nfl/NFL031_SF49ERS.png": 4103,
	"./Teams/nfl/NFL032_SSEAHAWKS.png": 96,
	"./Teams/wnba/WNBA001_Dream.png": 903,
	"./Teams/wnba/WNBA002_Sky.png": 6242,
	"./Teams/wnba/WNBA003_Sun.png": 6922,
	"./Teams/wnba/WNBA004_Wings.png": 9491,
	"./Teams/wnba/WNBA005_Valkyries.png": 2008,
	"./Teams/wnba/WNBA006_Fever.png": 2003,
	"./Teams/wnba/WNBA007_Aces.png": 2250,
	"./Teams/wnba/WNBA008_Sparks.png": 8337,
	"./Teams/wnba/WNBA009_Lynx.png": 7395,
	"./Teams/wnba/WNBA010_Liberty.png": 3805,
	"./Teams/wnba/WNBA011_Mercury.png": 3930,
	"./Teams/wnba/WNBA012_Storm.png": 7565,
	"./Teams/wnba/WNBA013_Tempo.png": 4434,
	"./Teams/wnba/WNBA014_Mystics.png": 3018,
	"./Teams/wnba/WNBA015_Fire.png": 3153,
	"./temp_icon.png": 3474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 512;